import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { HugeiconsIcon } from '@hugeicons/react';
import { UserGroupIcon } from '@hugeicons/core-free-icons';

const JoinAgent = () => {
  const { agentId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (agentId) {
      // Store the agent ID to bind the client
      localStorage.setItem('bound_agent_id', agentId);
      
      // Short delay for visual feedback if needed, then redirect to home
      const timer = setTimeout(() => {
        navigate('/', { replace: true });
      }, 1500);
      
      return () => clearTimeout(timer);
    }
  }, [agentId, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-off-white dark:bg-dark-bg px-4">
      <div className="text-center space-y-6 animate-in fade-in zoom-in duration-500">
        <div className="bg-soft-green/10 p-6 rounded-[2.5rem] inline-block mb-4 text-soft-green animate-float">
          <HugeiconsIcon icon={UserGroupIcon} size={64} />
        </div>
        <h1 className="text-3xl font-black text-charcoal dark:text-white tracking-tight">Connecting to Agent...</h1>
        <p className="text-muted-gray max-w-xs mx-auto">Setting up your private access to Safzi direct funding.</p>
        <div className="flex justify-center gap-2">
          <div className="w-2 h-2 bg-soft-green rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2 h-2 bg-soft-green rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-2 h-2 bg-soft-green rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
      </div>
    </div>
  );
};

export default JoinAgent;
